/**
 * Short descriptive subtexts for admin sidebar menu items.
 * Keys match translation keys or hardcoded labels in menu.vue.
 */
const MENU_SUBTEXTS = {
    'academic.academic': 'Classes & curriculum',
    'academic.academic_configuration': 'Academic setup options',
    'academic.academic_session': 'Year & terms',
    'academic.batch': 'Class sections',
    'academic.certificate': 'Certificates & awards',
    'academic.certificate_template': 'Certificate layouts',
    'academic.class_teacher': 'Homeroom assignments',
    'academic.class_timing': 'Period schedules',
    'academic.course': 'Programs & streams',
    'academic.course_group': 'Course groupings',
    'academic.id_card_template': 'ID card layouts',
    'academic.institute': 'Institute details',
    'academic.institute_other': 'Additional institute info',
    'academic.marksheet_template': 'Marksheet layouts',
    'academic.print_template': 'Printable layouts',
    'academic.subject': 'Subjects & syllabus',
    'academic.subject_teacher': 'Teacher assignments',
    'academic.teacher_timetable': 'Staff period schedule',
    'academic.timetable': 'Weekly class schedule',
    'asset.asset_configuration': 'Asset setup options',
    'asset.building': 'Building registry',
    'asset.room': 'Room management',
    'auth.authentication': 'Login & security',
    'auth.logout': 'Sign out',
    'Batch wise Report': 'Batch performance data',
    'calendar.calendar': 'Events & holidays',
    'calendar.calendar_configuration': 'Calendar setup options',
    'calendar.celebration': 'Celebrations & festivals',
    'calendar.celebration_templates': 'Celebration templates',
    'calendar.event': 'School events',
    'calendar.event_type': 'Event categories',
    'calendar.holiday': 'Holiday calendar',
    'communication.balance': 'Credit balance',
    'communication.communication': 'Messages & alerts',
    'communication.email': 'Email campaigns',
    'communication.history': 'Sent message log',
    'communication.meeting': 'Scheduled meetings',
    'communication.message_template': 'Message templates',
    'communication.my_meeting': 'Your meetings',
    'communication.my_notification': 'Your notifications',
    'communication.push_notification': 'Mobile push alerts',
    'communication.sms': 'SMS messaging',
    'communication.whatsapp': 'WhatsApp messaging',
    'configuration.basic_configuration': 'Core school settings',
    'configuration.configuration': 'System settings',
    'configuration.custom_field': 'Custom data fields',
    'configuration.locale': 'Language & region',
    'configuration.mail_configuration': 'Email server setup',
    'configuration.menu': 'Menu visibility',
    'configuration.module_configuration': 'Module enablement',
    'configuration.permission': 'Access permissions',
    'configuration.role': 'User role management',
    'configuration.sms_configuration': 'SMS gateway setup',
    'configuration.social_network': 'Social media links',
    'configuration.system_configuration': 'Advanced system options',
    'configuration.whatsapp_configuration': 'WhatsApp integration',
    'Course Group wise Report': 'Course group analysis',
    'download_center.content_share_list': 'Shared content list',
    'download_center.content_type': 'Content categories',
    'download_center.download_center': 'Shared resources',
    'download_center.upload_content': 'Upload materials',
    'download_center.video_tutorial': 'Video tutorials',
    'employee.attendance': 'Staff attendance',
    'employee.attendance_type': 'Attendance categories',
    'employee.category': 'Staff categories',
    'employee.department': 'Department structure',
    'employee.designation': 'Job titles',
    'employee.document_type_only': 'Document categories',
    'employee.employee': 'Staff & HR',
    'employee.employee_configuration': 'Staff setup options',
    'employee.employee_group': 'Staff groupings',
    'employee.employee_list': 'All staff profiles',
    'employee.id_card': 'Staff ID cards',
    'employee.import': 'Bulk staff import',
    'employee.leave': 'Leave requests',
    'employee.leave_type': 'Leave categories',
    'employee.pay_head': 'Salary components',
    'employee.payroll': 'Salary processing',
    'exam.assessment': 'Assessment types',
    'exam.authorities': 'Exam authorities',
    'exam.batch_wise_report': 'Batch performance data',
    'exam.configuration': 'Exam setup options',
    'exam.course_group_wise_report': 'Course group analysis',
    'exam.exam': 'Tests & results',
    'exam.exam_wise_report': 'Per-exam reports',
    'exam.grade': 'Grading scales',
    'exam.observation': 'Skill observations',
    'exam.online_exam': 'Digital assessments',
    'exam.record': 'Marks & grades',
    'exam.remark_rules': 'Remark guidelines',
    'exam.report': 'Exam reports',
    'exam.report_analysis': 'Performance analytics',
    'exam.report_card_attendance': 'Report card attendance',
    'exam.result_announcement': 'Result publishing',
    'exam.result_division_rules': 'Division criteria',
    'exam.schedule': 'Exam timetables',
    'exam.term': 'Exam terms',
    'exam.topper_report': 'Top performer lists',
    'finance.account': 'Chart of accounts',
    'finance.account_transfer': 'Inter-account transfers',
    'finance.expense': 'Expense transactions',
    'finance.fee_allocation': 'Fee assignments',
    'finance.fee_concession': 'Discounts & waivers',
    'finance.fee_group': 'Fee groupings',
    'finance.fee_head': 'Fee item types',
    'finance.finance': 'Fees & accounts',
    'finance.finance_configuration': 'Finance setup options',
    'finance.income': 'Income transactions',
    'finance.payment_gateway': 'Online payment setup',
    'finance.payment_method': 'Payment method types',
    'finance.transaction_category': 'Transaction categories',
    'frontend.block': 'Content blocks',
    'frontend.frontend': 'Public website',
    'frontend.frontend_configuration': 'Website setup options',
    'frontend.menu': 'Site navigation',
    'frontend.news_ticker': 'News ticker bar',
    'frontend.page': 'Website pages',
    'frontend.slider_image': 'Homepage sliders',
    'general.dashboard': 'Overview & insights',
    'general.general': 'Core settings',
    'general.report': 'Data & analytics',
    'hostel.facilities': 'Hostel amenities',
    'hostel.food_menu': 'Meal menu planning',
    'hostel.hostel': 'Boarding & rooms',
    'hostel.hostel_category': 'Hostel categories',
    'hostel.hostel_configuration': 'Hostel setup options',
    'hostel.hostel_incharge': 'Warden assignments',
    'hostel.meal_plan': 'Dietary meal plans',
    'hostel.meal_schedule': 'Dining schedules',
    'hostel.rooms': 'Room assignments',
    'incident.assign_incidents': 'Incident assignments',
    'incident.behaviour_records': 'Behaviour incidents',
    'incident.incidents': 'Incident tracking',
    'institute.document': 'Files & records',
    'inventory.inventory': 'Stock & supplies',
    'inventory.stock_category': 'Item categories',
    'inventory.stock_item': 'Stock item catalog',
    'inventory.stock_purchase': 'Purchase orders',
    'inventory.stock_transfer': 'Stock transfers',
    'inventory.vendor': 'Supplier registry',
    'library.book': 'Book catalog',
    'library.book_author': 'Author registry',
    'library.book_condition': 'Book condition types',
    'library.book_language': 'Language options',
    'library.book_publisher': 'Publisher registry',
    'library.book_topic': 'Subject topics',
    'library.issue': 'Book lending',
    'library.library': 'Books & lending',
    'library.library_configuration': 'Library setup options',
    'library.return': 'Book returns',
    'meet.class_and_meet': 'Virtual classrooms',
    'meet.live_class_report': 'Class session reports',
    'meet.live_classes': 'Live class sessions',
    'meet.live_meeting': 'Live meetings',
    'meet.live_meeting_report': 'Meeting attendance reports',
    'misc.blood_group': 'Blood group types',
    'misc.caste': 'Caste categories',
    'misc.category': 'General categories',
    'misc.disability_type': 'Disability types',
    'misc.medium_instruction': 'Instruction mediums',
    'misc.misc_configuration': 'Miscellaneous settings',
    'misc.religion': 'Religion options',
    'post.article': 'News articles',
    'post.article_type': 'Article categories',
    'post.feed': 'Activity feed',
    'post.post': 'Articles & feeds',
    'post.post_configuration': 'Post setup options',
    'reception.admission_enquiry': 'Prospective student leads',
    'reception.call_log': 'Incoming call records',
    'reception.calling_purpose': 'Call reason types',
    'reception.complaint': 'Issues & grievances',
    'reception.complaint_type': 'Complaint categories',
    'reception.enquiry_source': 'Lead source types',
    'reception.enquiry_type': 'Enquiry categories',
    'reception.gate_pass': 'Entry & exit passes',
    'reception.postal_record': 'Mail & parcels',
    'reception.reception': 'Front desk operations',
    'reception.reception_configuration': 'Reception setup options',
    'reception.visiting_purpose': 'Visit reason types',
    'reception.visitor_log': 'Guest check-in records',
    'reception.visitor_message': 'Guest communications',
    'reports.reports': 'Reports & analytics',
    'resource.assignment': 'Student assignments',
    'resource.curriculum_plan': 'Curriculum mapping',
    'resource.home_work': 'Homework tasks',
    'resource.lesson_plan': 'Lesson planning',
    'resource.lessons': 'Lesson content',
    'resource.manage_lesson_plan': 'Plan management',
    'resource.manage_syllabus_status': 'Syllabus progress',
    'resource.notes': 'Study notes',
    'resource.resource': 'Lessons & homework',
    'resource.subject_lesson_plan_report': 'Subject plan reports',
    'resource.syllabus': 'Syllabus structure',
    'resource.syllabus_status_report': 'Syllabus reports',
    'resource.syllabus_topic': 'Syllabus topics',
    'student.attendance': 'Daily attendance',
    'student.attendance_report': 'Attendance summaries',
    'student.class_monitor': 'Class representatives',
    'student.counsellor_report': 'Counselling notes',
    'student.document_type_only': 'Document categories',
    'student.favorites': 'Saved preferences',
    'student.house': 'House assignments',
    'student.id_card': 'Student ID cards',
    'student.image_upload': 'Photo management',
    'student.import': 'Bulk student import',
    'student.login': 'Portal access',
    'student.parent': 'Guardian contacts',
    'student.print_qr': 'QR code printing',
    'student.promotion': 'Class promotions',
    'student.qr_attendance': 'QR-based check-in',
    'student.registration': 'New admissions',
    'student.roll_number': 'Roll number assignment',
    'student.student': 'Profiles & records',
    'student.student_configuration': 'Student setup options',
    'student.student_group': 'Student groupings',
    'student.student_list': 'All student profiles',
    'student.student_questions': 'Custom form fields',
    'student.termination': 'Withdrawals & exits',
    'transport.document': 'Vehicle documents',
    'transport.fee': 'Transport fee setup',
    'transport.fuel': 'Fuel consumption log',
    'transport.log': 'Trip activity log',
    'transport.route': 'Bus route planning',
    'transport.service_record': 'Maintenance records',
    'transport.transport': 'Fleet & routes',
    'transport.transport_circle': 'Transport zones',
    'transport.transport_configuration': 'Transport setup options',
    'transport.transport_stoppage': 'Bus stop points',
    'transport.vehicle': 'Vehicle registry',
    'transport.vehicle_document_type_only': 'Document categories',
    'transport.vehicle_fuel_type': 'Fuel type options',
    'transport.vehicle_incharge': 'Vehicle supervisors',
    'transport.vehicle_service_center_only': 'Service centers',
    'user.change_password': 'Update password',
    'utility.activity_log': 'User activity log',
    'utility.backup': 'Database backups',
    'utility.email_log': 'Email delivery log',
    'utility.email_template': 'System email templates',
    'utility.ip_filter': 'IP access control',
    'utility.scheduled_job': 'Scheduled tasks',
    'utility.todo': 'Task reminders',
    'utility.utility': 'System utilities',
};

export function getMenuSubtext(key) {
    if (!key) {
        return '';
    }
    return MENU_SUBTEXTS[key] || '';
}

export default MENU_SUBTEXTS;
